const BACKDROP_CLASS = "backdrop";
const BACKDROP_SUBSCRIPTION_CLASS = "backdrop--subscription";
const BACKDROP_VISIBLE_CLASS = "backdrop--visible";
const DEFAULT_KEY = "default";
const BACKDROP_OPACITY_MS = 350;

export const BACKDROP_SUBSCRIBE_KEY = "subscribe-modal";

const activeKeys = new Set();
let backdropElement = null;
let subscriptionModifierGeneration = 0;
let subscriptionHideFallbackTimer = null;
let subscriptionHideListener = null;

const ensureBackdropElement = (documentReference) => {
  if (backdropElement?.isConnected) {
    return backdropElement;
  }

  const element = documentReference.createElement("div");
  element.className = BACKDROP_CLASS;
  element.setAttribute("aria-hidden", "true");
  documentReference.body.append(element);
  backdropElement = element;
  return element;
};

const clearSubscriptionHideScheduling = (element) => {
  if (subscriptionHideFallbackTimer !== null) {
    clearTimeout(subscriptionHideFallbackTimer);
    subscriptionHideFallbackTimer = null;
  }
  if (subscriptionHideListener) {
    element.removeEventListener("transitionend", subscriptionHideListener);
    subscriptionHideListener = null;
  }
};

const scheduleSubscriptionModifierRemoval = (element) => {
  clearSubscriptionHideScheduling(element);

  const generation = subscriptionModifierGeneration;

  const finish = () => {
    if (generation !== subscriptionModifierGeneration) {
      return;
    }
    element.classList.remove(BACKDROP_SUBSCRIPTION_CLASS);
  };

  const onTransitionEnd = (event) => {
    if (event.target !== element || event.propertyName !== "opacity") {
      return;
    }
    clearSubscriptionHideScheduling(element);
    finish();
  };

  subscriptionHideListener = onTransitionEnd;
  element.addEventListener("transitionend", onTransitionEnd);
  subscriptionHideFallbackTimer = window.setTimeout(() => {
    clearSubscriptionHideScheduling(element);
    finish();
  }, BACKDROP_OPACITY_MS + 50);
};

const syncBackdropVisibility = (documentReference) => {
  const element = ensureBackdropElement(documentReference);
  const isVisible = activeKeys.size > 0;

  if (isVisible) {
    subscriptionModifierGeneration += 1;
    clearSubscriptionHideScheduling(element);
    element.classList.add(BACKDROP_VISIBLE_CLASS);
    element.classList.toggle(BACKDROP_SUBSCRIPTION_CLASS, activeKeys.has(BACKDROP_SUBSCRIBE_KEY));
    return;
  }

  element.classList.remove(BACKDROP_VISIBLE_CLASS);

  if (!element.classList.contains(BACKDROP_SUBSCRIPTION_CLASS)) {
    return;
  }

  scheduleSubscriptionModifierRemoval(element);
};

export const showBackdrop = (key = DEFAULT_KEY, documentReference = document) => {
  activeKeys.add(String(key));
  syncBackdropVisibility(documentReference);
};

export const hideBackdrop = (key = DEFAULT_KEY, documentReference = document) => {
  activeKeys.delete(String(key));
  syncBackdropVisibility(documentReference);
};
